<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh; display: flex;margin-top: -70px;"
  >

    <h2 class="text-center" style="width: 100%;">
      <v-icon x-large class="mb-5">mdi-close-octagon-outline</v-icon>
      <br />
      Not available on mobile
    </h2>
  </v-col>
  <v-container v-else fluid style="height: calc(100vh);">
    <v-row cols="12" class="v-card v-sheet theme--light mx-auto fill-height" :style="`min-height: calc(100vh - 24px - ${!$store.state.auth.default_user ? '0px' : '24px'})`">
      <v-col :cols="bonusTemplate ? 6 : 12" class="transition-ease-in-out pb-0">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="filteredItems"
          :disable-pagination="true"
          fixed-header
          hide-default-footer
          single-select
          show-select
          item-key="bonus_template_id"
          @item-selected="selectTemplate"
          class="th-nowrap"
          :height="`calc(100vh - 120px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
          :loading="loadingBonusTemplate"
        >
          <template v-slot:body.prepend>
            <tr v-if="Object.keys(filters).length > 0" class="">
              <td style="height: 35px;"></td>
              <td style="height: 35px;"></td>
              <td style="height: 35px;">
                <v-text-field
                  class="pt-0 mt-0"
                  v-model="filters.name.data"
                  :style="{width: (filters.name || {width: false}).width}"
                  hide-details
                />
              </td>
              <td style="height: 35px;"></td>
            </tr>
          </template>
          <template v-slot:top>
            <v-row class="mx-auto">
              <select-project
                v-model="entity_id"
              >
              </select-project>
              <v-checkbox
                label="Hide Inactive"
                v-model="hideInactive"
                hide-details
                class="ml-2"
              />
              <v-spacer></v-spacer>

              <v-btn
                v-if="$store.state.auth.checkAccess({key: 'bonus_template_update', value: true})"
                class="mt-3"
                color="success"
                @click="newTemplate()">
                <v-icon left>mdi-pencil</v-icon>
                New
              </v-btn>
            </v-row>
          </template>

        </v-data-table>
      </v-col>
      <v-col cols="6" class="transition-ease-in-out pb-0" :hidden="!bonusTemplate">
        <update-form :bonusTemplate="bonusTemplate" :loading="loadingBonusTemplate" @update-validation="updateFormValidation" class="overflow-y-auto" :style="`height: calc(100vh - 94px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"></update-form>
        <v-divider class="mb-2" />
        <v-row class="mx-auto px-6 divider-border">
          <v-btn
            v-if="$store.state.auth.checkAccess({key: 'bonus_template_update', value: true})"
            :loading="loadingBonusTemplate"
            :disabled="!validUpdateForm || (bonusTemplate.data || []).length === 0"
            @click="save()"
            color="primary"
          >Save
          </v-btn>
          <v-btn
            class="ml-1"
            icon
            outlined
            color="primary"
            :loading="loadingBonusTemplate"
            @click="isCopyingTemplate = true"
          >
            <v-icon v-text="'mdi-file'" />
          </v-btn>
          <v-btn
            class="ml-2"
            color="primary"
            @click="onClone"
          >
            Clone & Modify
          </v-btn>
          <v-spacer></v-spacer>
          <v-switch
            v-if="bonusTemplate"
            color="red"
            class="switch-deleted mt-0"
            v-model="bonusTemplate.deleted"
            :label="bonusTemplate.deleted ? 'Disabled' : 'Enabled'"
          ></v-switch>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loadingBonusTemplate"
            @click="bonusTemplate = false; selected= [];"
            color="warning"
          >Close
          </v-btn>
        </v-row>
      </v-col>
    </v-row>


    <v-dialog
      v-model="isCopyingTemplate"
      max-width="600"
    >
      <v-card>
        <v-card-title v-text="'Copy Bonus Template'" />
        <v-card-text>
          <v-autocomplete
            v-model="copyTargetEntities"
            :items="getCopyTargetEntities()"
            label="Select projects to copy this bonus template for"
            :loading="loadingBonusTemplate"
            multiple
          />

          <v-alert
            class="mt-1"
            type="warning"
          >
            If this bonus template is configured for specific games, make sure to manually check the copied result because game availability varies depending on the project.
          </v-alert>
        </v-card-text>
        <v-card-actions
          class="justify-end"
        >
          <v-btn
            v-text="'Cancel'"
            color="error"
            :loading="loadingBonusTemplate"
            @click="isCopyingTemplate = false"
          />
          <v-btn
            v-text="'Apply'"
            color="primary"
            :disabled="!copyTargetEntities.length"
            :loading="loadingBonusTemplate"
            @click="onConfirmCopy"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isCloning" max-width="900">
    <v-card v-if="isCloning">
      <v-card-title class="d-flex align-center justify-space-between">
        <span>Cloning <strong>{{ cloneTarget.name }}</strong></span>

        <div class="d-flex align-center">
          <v-btn
            icon
            color="error"
            :disabled="cloningDone"
            @click="cloneAttrs.splice(cloneAttrs.length - 1, 1)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn
            icon
            color="primary"
            :disabled="cloningDone"
            @click="addCloneEntry"
          >
            <v-icon>mdi-plus-box</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-row class="mx-0" dense>
        <v-col
          v-for="(attrs, idx) in cloneAttrs"
          :key="attrs.id || idx"
          cols="4"
        >
          <v-card
            outlined
            class="pa-2"
            disableds
            :style="attrs.done ? 'border-color: #4caf50' : ''"
            :disabled="attrs.done"
          >

            <v-card-title class="d-flex pa-0">

              <v-text-field
                v-model="attrs.name"
                class="my-2"
                label="Bonus Template Name"
                hide-details
                dense
              />
            </v-card-title>

            <v-card-text class="pa-0">
              <div v-for="(bonus, bIdx) in attrs.amounts" :key="bIdx">
                <v-card flat class="mt-2 pa-2">
                  <strong class="mb-1">Bonus Type: {{ bonus.type }}</strong>

                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        v-model="bonus.name"
                        class="my-2"
                        label="Bonus Name"
                        hide-details
                        dense
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-if="!bonus.amount_by_day?.length"
                        v-model="bonus.amount"
                        label="Amount"
                        hide-details
                        dense
                      />

                      <template v-else>
                        <v-text-field
                          v-for="(_, day) in bonus.amount_by_day"
                          :key="day"
                          v-model="bonus.amount_by_day[day]"
                          :label="`Day ${day + 1}`"
                          hide-details
                        />
                      </template>
                    </v-col>
                  </v-row>
                </v-card>

                <v-divider v-if="bIdx < attrs.amounts.length - 1" class="mt-2" />
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-card-actions class="d-flex justify-end">
        <v-btn
          text
          :loading="loadingBonusTemplate"
          @click="isCloning = false"
        >
          Close
        </v-btn>
        <v-btn
          color="primary"
          :loading="loadingBonusTemplate"
          @click="saveClones"
          :disabled="cloningDone"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-container>
</template>
<style>
  .nowrap,
  .th-nowrap th {
    white-space: nowrap;
  }

  .switch-deleted .v-input--selection-controls__ripple,
  .switch-deleted .v-input--switch__track,
  .switch-deleted .v-input--switch__thumb {
    color: #4CAF50 !important;
    caret-color: #4CAF50 !important;
  }

  .switch-deleted .red--text {
    color: #F44336 !important;
    caret-color: #F44336 !important;
  }
</style>

<script>
  import { cloneDeep } from 'lodash'
  import { API } from '@/utils/api'
  import { map } from 'lodash'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    components: {
      SelectProject,
      UpdateForm: () => import('@/components/bonus-template/UpdateForm'),
    },

    data: () => ({
      bonusTemplate: false,
      hideInactive: true,
      validUpdateForm: false,
      loadingBonusTemplate: false,
      selected: [],
      entity_id: null,
      headers: [
        { text: 'ID', value: 'bonus_template_id', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: '', value: 'action', sortable: true },
      ],
      filters: {
        name: { data: [], type: 'text' },
      },
      items: [],

      isCopyingTemplate: false,
      copyTargetEntities: [],
      cloneTarget: null,
      cloneAttrs: [],
    }),

    computed: {
      filteredItems () {
        return this.items.filter(o => {
          return (this.hideInactive ? o.deleted == 0 : true) && (this.filters.name.data.length > 0 ? o.name.toLowerCase().indexOf(this.filters.name.data.toString().toLowerCase()) != -1 : true)
        })
      },

      projectList: function () {
        return map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id }))
      },

      isCloning: {
        get() {
          return !!this.cloneTarget
        },

        set(value) {
          if (!value) {
            this.cloneTarget = null
            this.cloneAttrs = []
          }
        }
      },

      cloningDone() {
        return this.cloneAttrs.every(attr => attr.done)
      },
    },

    watch: {
      entity_id (val) {
        this.entity_id = val
        this.loadBonusTemplateList()
      },
    },

    methods: {
      updateFormValidation (value) {
        this.validUpdateForm = value
      },
      save () {
        if (!this.$store.state.auth.checkAccess({ key: 'bonus_template_update', value: true })) return

        this.$root.$confirm('Confirm', 'Save bonus template').then(r => {
          if (!r) return

          this.loadingBonusTemplate = true
          API.call('/$v/bonus_template/update.json', { bonusTemplate: this.bonusTemplate }, null, this.bonusTemplate.entity_id)
            .then(resp => {
              this.bonusTemplate = resp.data
              return resp
            })
            .then(resp => {
              this.bonusTemplate = false
              this.selected = []
            })
            .then(resp => this.loadBonusTemplateList())
            .catch(e => {
            })
            .finally(() => {
              this.loadingBonusTemplate = false
            })
        })
      },

      newTemplate () {
        this.bonusTemplate = { new: true, data: [], entity_id: this.entity_id }
        this.loadingBonusTemplate = false
        this.selected = []
      },

      loadBonusTemplateList () {
        this.loadingBonusTemplate = true
        return API.call('/$v/bonus_template/list.json', {}, null, this.entity_id).then(resp => {
          this.items = resp.data
        }).finally(() => {
          this.loadingBonusTemplate = false
        })
      },

      loadBonusTemplate (bonus_template_id) {
        this.loadingBonusTemplate = true
        return API.call('/$v/bonus_template/get.json', { bonus_template_id }, null, this.entity_id).then(resp => {
          this.bonusTemplate = resp.data
        }).finally(() => {
          this.loadingBonusTemplate = false
        })
      },

      selectTemplate (data) {
        if (data.value) {
          this.loadBonusTemplate(data.item.bonus_template_id)
        } else {
          this.bonusTemplate = false
        }
        // this.bonusTemplate = data.value ? cloneDeep(data.item) : false
      },

      async onConfirmCopy() {
        const yes = await this.$root.$confirm('Confirm', 'Are you sure you want to copy this template?')

        if (!yes) {
          return
        }

        const { bonus_template_id: _, ...copySource } = this.bonusTemplate
        const copiedTemplates = this.copyTargetEntities.map(entityId => ({
          ...copySource,
          name: `Copied - ${copySource.name}`,
          entity_id: entityId,
        }))

        this.loadingBonusTemplate = true
        for (let i = 0; i < copiedTemplates.length; i++) {
          const template = copiedTemplates[i]
          try {
            await API.call('/$v/bonus_template/update.json', { bonusTemplate: template }, null, template.entity_id)
          } catch {
            this.$showError(`Error copying ${copySource.name} template for project ${i + 1} of ${copiedTemplates.length}`)
          }
        }

        this.loadingBonusTemplate = false
        this.isCopyingTemplate = false
        this.$showSuccess(`Successfully copied ${copySource.name}`)
      },


      getCopyTargetEntities() {
        if (!this.isCopyingTemplate) {
          return []
        }

        return this.projectList.filter(({value}) => value !== this.bonusTemplate.entity_id)
      },

      onClone() {
        this.cloneTarget = this.bonusTemplate
        this.cloneAttrs = []
        this.addCloneEntry()
      },

      addCloneEntry() {
        this.cloneAttrs.push({
          name: this.cloneTarget.name,
          done: false,
          amounts: this.cloneTarget.data.map(bonus => ({
            type: bonus.type,
            name: bonus.name,
            amount: bonus.amount,
            amount_by_day: bonus.amount_by_day,
          }))
        })
      },

      saveClones() {
        this.$root.$confirm('Confirm', `Create ${this.cloneAttrs.length} clones for the ${this.cloneTarget.name} template?`)
          .then(async yes => {
            if (!yes) {
              return
            }

            const { bonus_template_id: _, ...base } = cloneDeep(this.cloneTarget)

            for (const attrs of this.cloneAttrs) {
              base.name = attrs.name
              for (let i = 0; i < attrs.amounts.length; i++) {
                if (attrs.amounts[i].amount_by_day?.length) {
                  base.data[i].amount_by_day = attrs.amounts[i].amount_by_day
                } else {
                  base.data[i].amount = attrs.amounts[i].amount
                }

                if (attrs.amounts[i].name) {
                  base.data[i].name = attrs.amounts[i].name
                }
              }

              this.loadingBonusTemplate = true
              await API.call('/$v/bonus_template/update.json', { bonusTemplate: base }, null, base.entity_id)
                .finally(() => {
                  this.loadingBonusTemplate = false
                })
              attrs.done = true
            }

            this.$showSuccess('Created clones successfully')
          })
      },
    }
  }
</script>
